import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import * as serviceWorkerRegistration from "./service-worker-registration";

import "./global.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);

// Registrar o Service Worker para funcionalidade PWA
serviceWorkerRegistration.register({
  onSuccess: () => console.log('Aplicação em cache para uso offline'),
  onUpdate: () => console.log('Nova versão disponível! Por favor, recarregue.')
});
